import React from 'react';
import { Bot, ShieldAlert, AlertTriangle, CheckCircle2, X, Info } from 'lucide-react';
import './AiDisclaimerCard.css';

/**
 * AiDisclaimerCard
 *
 * Props:
 *   featureName  {string}   – e.g. "AI Interviewer", "Skill Gap Analysis"
 *   onAgree      {function} – called when the user clicks "I Agree & Continue"
 *   onCancel     {function} – called when the user dismisses / clicks Cancel (optional)
 */
const BULLETS = [
  {
    icon: <Bot size={17} />,
    text: 'Scores, evaluations, feedback, and insights are generated automatically by AI.',
  },
  {
    icon: <AlertTriangle size={17} />,
    text: 'AI can make mistakes - always verify important information independently.',
  },
  {
    icon: <Info size={17} />,
    text: 'Results are intended solely for practice, skill development, and self-improvement benchmarking.',
  },
  {
    icon: <ShieldAlert size={17} />,
    text: 'Outputs do not constitute official hiring decisions, academic grades, employment guarantees, or any form of certified assessment.',
  },
];

export default function AiDisclaimerCard({ featureName = 'AI Feature', onAgree, onCancel }) {
  return (
    <div className="ai-disclaimer-overlay" role="dialog" aria-modal="true" aria-labelledby="ai-disclaimer-title">
      <div className="ai-disclaimer-card">

        {/* ── Header ── */}
        <div className="ai-disclaimer-header">
          <div className="ai-disclaimer-icon-wrap">
            <ShieldAlert size={22} />
          </div>
          <div className="ai-disclaimer-header-text">
            <h2 id="ai-disclaimer-title" className="ai-disclaimer-title">
              {featureName}
            </h2>
            <p className="ai-disclaimer-subtitle">
              Before continuing, please read the advisory notice below. This notice applies to all AI features
            </p>
          </div>
          {onCancel && (
            <button
              className="ai-disclaimer-close"
              onClick={onCancel}
              aria-label="Close disclaimer"
            >
              <X size={18} />
            </button>
          )}
        </div>

        {/* ── Divider ── */}
        <div className="ai-disclaimer-divider" />

        {/* ── Bullet points ── */}
        <ul className="ai-disclaimer-bullets" aria-label="AI advisory points">
          {BULLETS.map((item, index) => (
            <li key={index} className="ai-disclaimer-bullet">
              <span className="ai-disclaimer-bullet-icon">{item.icon}</span>
              <span className="ai-disclaimer-bullet-text">{item.text}</span>
            </li>
          ))}
        </ul>

        {/* ── Legal note ── */}
        <div className="ai-disclaimer-legal">
          <ShieldAlert size={14} />
          <span>
            By continuing you acknowledge this is an AI-assisted tool provided for educational and
            developmental purposes only.
          </span>
        </div>

        {/* ── Actions ── */}
        <div className="ai-disclaimer-actions">
          {onCancel && (
            <button className="ai-disclaimer-btn-cancel" onClick={onCancel}>
              Cancel
            </button>
          )}
          <button className="ai-disclaimer-btn-agree" onClick={onAgree}>
            <CheckCircle2 size={17} />
            I Agree &amp; Continue
          </button>
        </div>

      </div>
    </div>
  );
}
